import type { AppRouteObject } from "../routes";
import { UserApprovalRoute } from "./routes/UserApprovalRoute";

const routes: AppRouteObject[] = [
  UserApprovalRoute,
];

export default routes;
